import Vue from 'vue'

export default Vue.extend({
  template: `
    <span
        v-b-tooltip title="Открыть отчет"
        class="send-button fas fa-file-alt text-primary text-center"
        @click="onClick(params)"
    ></span>
  `,
  data() {
    return {
    }
  },
  methods: {
    onClick() {
      this.params.context.componentParent.onParentReportClicked(this.params.node.data)
    }
  }
})
